import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
  Box,
} from "@mui/material";
import { useOrgan } from "../../hooks/useOrgan";
import { organizationPrimaryColors } from "../../layouts/PermanentSidebarMUI";

export default function TableSkeleton({
  rows = 10,
  columns = 5,
  showActions = true,
}) {
  const { selectedOrgan } = useOrgan();
  const primaryColor = selectedOrgan?.name
    ? organizationPrimaryColors[selectedOrgan.name.toUpperCase()] ||
      organizationPrimaryColors.ALUCOM
    : organizationPrimaryColors.ALUCOM;

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer
        component={Paper}
        sx={{ width: "100%", mt: 2, overflowX: "auto" }}>
        <Table sx={{ minWidth: 1000, width: "100%" }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: primaryColor }}>
              <TableCell sx={{ width: 50 }} />
              {Array.from({ length: columns }).map((_, idx) => (
                <TableCell
                  key={idx}
                  sx={{
                    backgroundColor: "transparent",
                    minWidth: 100,
                  }}>
                  <Skeleton
                    variant="text"
                    width="60%"
                    sx={{ bgcolor: "rgba(255,255,255,0.3)" }}
                  />
                </TableCell>
              ))}
              {showActions && (
                <TableCell
                  align="center"
                  sx={{ backgroundColor: "transparent", minWidth: 80 }}>
                  <Skeleton
                    variant="text"
                    width="60%"
                    sx={{ bgcolor: "rgba(255,255,255,0.3)" }}
                  />
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: rows }).map((_, rowIdx) => (
              <TableRow key={rowIdx} hover={false}>
                <TableCell>
                  <Skeleton variant="circular" width={24} height={24} />
                </TableCell>
                {Array.from({ length: columns }).map((_, colIdx) => (
                  <TableCell key={colIdx}>
                    <Skeleton
                      variant="text"
                      width={colIdx === 0 ? "40%" : "70%"}
                      animation="wave"
                    />
                  </TableCell>
                ))}
                {showActions && (
                  <TableCell align="center">
                    <Skeleton variant="circular" width={28} height={28} />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Rodapé com paginação skeleton */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 2,
          borderTop: "1px solid rgba(224, 224, 224, 1)",
        }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Skeleton variant="text" width={100} />
          <Skeleton variant="rectangular" width={70} height={32} />
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="circular" width={32} height={32} />
        </Box>
        <Skeleton variant="text" width={120} />
      </Box>
    </Paper>
  );
}
